<template>
  <div class="roll-content roll-info">
    <div class="zz-page roll-detail-page">
      <div class="page-content-new flex-box-div">
        <otherHeaderTop
          headerTitle="ROLL房"
          :showBack="true"
          @back="back"
          :showBalanceOne="false"
        ></otherHeaderTop>
        <div class="roll-header">
          <div class="room-type type-1">
            <!-- <div v-if="info.user_id == 0">官方</div>
            <div v-else>推广</div> -->
            <div>{{ obj.rollTypeName }}</div>
          </div>
          <div class="info-1">
            <div class="avatar">
              <img alt="" :src="obj.jackpotOrnamentsDataList[0].imgUrl" />
            </div>
            <div class="info-1-middle">
              <div class="name text-ellipsis">{{ obj.rollName }}</div>
              <div class="time">
                <div>{{ obj.endTime }}</div>
              </div>
            </div>
            <div class="join-btn">
              <span v-if="obj.rollStatus == 0 && isUserJoined"> 已加入 </span>
              <span v-else-if="obj.rollStatus == 0" @click="handlejoin">
                立即加入
              </span>
              <span v-if="obj.rollStatus == 1">已结束</span>
            </div>
          </div>
        </div>
        <div class="roll-detail-content">
          <div role="feed" class="van-list roll-vant-list">
            <div class="roll-info">
              <div class="info-2">
                <div
                  class="desc-item"
                  v-for="(condition, index) in [info.desc]"
                  :key="index"
                >
                  <img
                    src="../../../assets/images/register-icon.png"
                    alt=""
                    class="icon"
                  />
                  <div class="desc-text">
                    参与条件:{{
                      obj.minRecharge == 0
                        ? "所有用户均可参与"
                        : `自开启之日起充值${obj.minRecharge}即可参与`
                    }}
                  </div>
                </div>
                <div class="tip-text">
                  <div class="text"></div>
                </div>
              </div>
            </div>

            <div class="prod-list-wrap">
              <div class="list-title">
                <img src="../../../assets/images/prod_list_title.png" alt="" />
              </div>
              <div class="prod-list-content" @scroll="rollPrizePoolScroll">
                <div class="list">
                  <div
                    class="prod-item"
                    v-for="(item, index) in rollPrizePool"
                    :key="index"
                  >
                    <div class="top">
                      <div class="prod-img flex-center" style="">
                        <img
                          :src="$getFullPath(item.imgUrl)"
                          alt=""
                          style="width: 100rpx"
                          mode="widthFix"
                        />
                      </div>
                      <!-- <div v-if="item.roll_user_id" class="user-info">
                        <img
                          class="avatar"
                          :src="
                            item.prizer.avatarUrl
                              ? item.prizer.avatarUrl
                              : '../../../assets/images/default-header.png'
                          "
                          mode="aspectFit"
                        />
                        <div class="nick">{{ item.prizer.nickName }}</div>
                      </div> -->
                    </div>
                    <div class="bottom">
                      <div class="name text-ellipsis" style="font-size: 24rpx">
                        {{ item.ornamentName }}
                      </div>
                      <div class="price">
                        <img
                          src="../../../assets/images/balance3.png"
                          class="bi"
                          mode="aspectFit"
                        />
                        <span style="font-size: 26rpx">{{ item.price }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="got-top hide">
              <div class="go-img"></div>
            </div>
          </div>
        </div>
        <div
          class="bottom-user-list-wrap"
          :class="[showJoinInfo ? 'open' : '']"
        >
          <div class="line-box"></div>
          <div
            v-if="showJoinInfo"
            class="close-btn"
            style="height: calc(100vh - 143.33 * 4.2px)"
          ></div>
          <div
            class="top-row"
            @click="openJoinUsers"
            :class="[showJoinInfo ? 'sel' : '']"
          >
            参与详情
          </div>
          <div
            class="bottom-middle-content"
            :style="{ height: showJoinInfo ? '600px' : '78px' }"
          >
            <div class="total-box" style="display: flex; align-items: center">
              <div class="total-item" style="flex: 1; justify-content: left">
                <span>饰品件数</span>
                <span>{{ obj.ornamentsNum }}</span>
              </div>
              <div class="total-item" style="flex: 1">
                <span>参与人数</span>
                <span>{{ obj.peopleNum }}</span>
              </div>
              <div class="total-item" style="flex: 1; justify-content: right">
                <span>饰品价值</span>
                <span>{{ obj.totalOrnamentsPrice }}</span>
              </div>
            </div>
            <div
              class="user-list-wrap"
              style="height: 127.33 * 4.2px"
              @scroll="RollPlayersScroll"
            >
              <div class="user-list-content">
                <div
                  class="user-item"
                  v-for="(user, index) in playerList"
                  :key="index"
                >
                  <div class="avatar">
                    <img
                      :src="`${$getFullPath(user.avatar)}`"
                      alt=""
                      mode="aspectFit"
                    />
                    <!-- <img
                      :src="
                        user.avatar
                          ? user.avatar
                          : '../../../assets/images/default-header.png'
                      "
                      alt=""
                      mode="aspectFit"
                    /> -->
                  </div>
                  <div class="nick van-multi-ellipsis--l2">
                    {{ user.nickName }}
                  </div>
                </div>
              </div>
              <div
                style="width: 100%; margin-top: 30%"
                v-if="playerList.length == 0"
              >
                <div class="no-data">
                  <div class="empty-box-new"></div>
                  <div class="tip-text">暂无数据</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom-row"></div>
        </div>
      </div>
    </div>
    <div class="home" v-if="false">
      <div class="header_top">
        <handleback></handleback>
        <div>{{ obj.rollTypeName || "加载中" }}</div>
        <div
          @click="
            handleilltate();
            playAudio();
          "
        >
          玩法说明
        </div>
      </div>
      <!-- <div class="header"> -->
      <div
        :class="{
          'header finish': obj.rollStatus == 1,
          'header anchor': obj.rollStatus != 1 && obj.rollType == 1,
          'header official': obj.rollStatus != 1 && obj.rollType == 0,
        }"
      >
        <div class="top-bg roomType0"></div>
        <div class="room_content">
          <div class="room_top space_around">
            <div class="room_title left">
              <div class="room_type center">{{ obj.rollTypeName }}</div>
              <div class="room_name left">{{ obj.rollName }}</div>
            </div>
            <div class="room_detial space_around">
              <div class="detial_public center">
                <svg
                  t="1706769767743"
                  class="icon"
                  divBox="0 0 1024 1024"
                  version="1.1"
                  p-id="3482"
                >
                  <path
                    d="M650.24 230.4H921.6c43.52 0 76.8 33.28 76.8 76.8s-33.28 76.8-76.8 76.8H102.4c-43.52 0-76.8-33.28-76.8-76.8s33.28-76.8 76.8-76.8h271.36l-102.4-58.88C235.52 151.04 222.72 102.4 243.2 66.56s69.12-48.64 104.96-28.16L512 133.12l163.84-94.72c35.84-20.48 84.48-7.68 104.96 28.16 20.48 35.84 7.68 84.48-28.16 104.96l-102.4 58.88zM153.6 435.2h716.8c43.52 0 76.8 33.28 76.8 76.8v409.6c0 43.52-33.28 76.8-76.8 76.8H153.6c-43.52 0-76.8-33.28-76.8-76.8V512c0-43.52 33.28-76.8 76.8-76.8z"
                    fill="#3A97E4"
                    p-id="3483"
                  />
                </svg>
                {{ obj.ornamentsNum }}
              </div>
              <div class="detial_public center">
                <svg
                  t="1706770215849"
                  class="icon"
                  divBox="0 0 1024 1024"
                  version="1.1"
                  p-id="3627"
                >
                  <path
                    d="M164.445091 330.984727c0-95.604364 79.080727-173.102545 176.64-173.102545 97.605818 0 176.686545 77.498182 176.686545 173.102545s-79.127273 173.102545-176.686545 173.102546-176.64-77.498182-176.64-173.102546zM407.272727 808.354909v-11.962182c0-88.250182 45.986909-165.794909 115.339637-211.502545a230.958545 230.958545 0 0 0-100.491637-23.086546H274.850909c-126.045091 0-228.212364 100.072727-228.212364 223.557819v14.42909c0 50.501818 102.167273 50.501818 228.212364 50.501819H415.650909a101.841455 101.841455 0 0 1-8.378182-41.937455z m313.623273-532.852364c-80.942545 0-146.618182 64.325818-146.618182 143.685819s65.675636 143.685818 146.618182 143.685818c80.989091 0 146.618182-64.325818 146.618182-143.685818s-65.582545-143.685818-146.618182-143.685819z m0 0c-80.942545 0-146.618182 64.325818-146.618182 143.685819s65.675636 143.685818 146.618182 143.685818c80.989091 0 146.618182-64.325818 146.618182-143.685818s-65.582545-143.685818-146.618182-143.685819z m-54.923636 335.313455c-104.634182 0-189.44 83.083636-189.44 185.576727v11.962182c0 41.890909 84.805818 41.890909 189.44 41.890909h122.228363c104.587636 0 189.346909-1.536 189.346909-41.890909v-11.962182c0-102.493091-84.759273-185.576727-189.346909-185.576727h-122.228363z m0 0"
                    fill="#727477"
                    p-id="3628"
                  />
                </svg>
                {{ obj.currentPeopleNum }} / {{ obj.peopleNum }}
              </div>
              <div
                class="detial_public center"
                style="color: rgba(37, 244, 132, 1)"
              >
                <svg
                  t="1706770289544"
                  class="icon"
                  divBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3776"
                >
                  <path
                    d="M955.733333 511.931733q0 10.922667-0.546133 21.777067-0.512 10.888533-1.604267 21.7088-1.024 10.8544-2.6624 21.640533-1.604267 10.752-3.720533 21.435734t-4.778667 21.265066q-2.628267 10.581333-5.802666 20.957867-3.140267 10.4448-6.826667 20.6848-3.652267 10.24-7.850667 20.343467-4.164267 10.0352-8.8064 19.899733-4.676267 9.8304-9.796266 19.456-5.12 9.591467-10.717867 18.944-5.632 9.3184-11.6736 18.397867-6.0416 9.045333-12.526933 17.783466-6.485333 8.772267-13.4144 17.169067-6.894933 8.430933-14.2336 16.4864-7.304533 8.0896-15.018667 15.7696-7.68 7.714133-15.7696 15.018667-8.055467 7.338667-16.4864 14.2336-8.430933 6.929067-17.169067 13.4144t-17.8176 12.526933q-9.045333 6.0416-18.397866 11.639467-9.3184 5.597867-18.944 10.752-9.591467 5.12-19.456 9.796266-9.8304 4.642133-19.899734 8.8064t-20.309333 7.850667q-10.24 3.652267-20.6848 6.826667-10.4448 3.1744-20.992 5.802666-10.581333 2.6624-21.265067 4.778667-10.683733 2.116267-21.469866 3.720533-10.752 1.604267-21.6064 2.6624-10.820267 1.058133-21.7088 1.604267t-21.777067 0.546133q-10.922667 0-21.777067-0.546133-10.888533-0.546133-21.7088-1.604267-10.8544-1.058133-21.640533-2.6624-10.752-1.604267-21.435733-3.754666-10.683733-2.082133-21.265067-4.744534-10.581333-2.628267-20.992-5.802666-10.410667-3.1744-20.6848-6.826667-10.24-3.6864-20.309333-7.850667-10.069333-4.164267-19.899734-8.8064-9.864533-4.676267-19.456-9.796266-9.6256-5.12-18.944-10.752-9.352533-5.597867-18.432-11.605334-9.045333-6.075733-17.783466-12.561066t-17.169067-13.4144q-8.430933-6.894933-16.4864-14.199467-8.0896-7.338667-15.7696-15.018667-7.714133-7.714133-15.018667-15.803733-7.338667-8.055467-14.2336-16.4864-6.929067-8.3968-13.4144-17.169067-6.485333-8.738133-12.526933-17.783466t-11.639467-18.432q-5.632-9.3184-10.752-18.909867-5.12-9.6256-9.796266-19.456-4.642133-9.864533-8.8064-19.899733-4.1984-10.069333-7.850667-20.343467-3.6864-10.24-6.826667-20.650667-3.1744-10.4448-5.802666-20.992-2.6624-10.581333-4.778667-21.265066-2.116267-10.683733-3.754667-21.435734-1.570133-10.786133-2.628266-21.640533-1.092267-10.820267-1.604267-21.7088Q68.266667 522.820267 68.266667 511.931733t0.546133-21.742933q0.512-10.922667 1.604267-21.742933 1.024-10.820267 2.6624-21.6064 1.604267-10.786133 3.720533-21.435734 2.116267-10.683733 4.778667-21.265066 2.628267-10.581333 5.802666-20.992 3.140267-10.410667 6.826667-20.6848 3.652267-10.24 7.850667-20.309334 4.164267-10.069333 8.8064-19.899733 4.676267-9.864533 9.796266-19.456 5.12-9.591467 10.752-18.944 5.597867-9.352533 11.605334-18.432 6.075733-9.0112 12.561066-17.749333 6.485333-8.772267 13.4144-17.2032 6.894933-8.3968 14.2336-16.4864 7.304533-8.055467 15.018667-15.7696 7.68-7.714133 15.7696-15.018667 8.055467-7.304533 16.4864-14.2336 8.430933-6.894933 17.169067-13.380267t17.8176-12.526933q9.045333-6.075733 18.397866-11.6736 9.3184-5.597867 18.944-10.717867 9.591467-5.12 19.456-9.796266 9.8304-4.642133 19.899734-8.840534 10.069333-4.164267 20.309333-7.850666 10.24-3.652267 20.6848-6.826667 10.4448-3.140267 20.992-5.802667 10.581333-2.628267 21.265067-4.778666 10.683733-2.082133 21.435733-3.6864 10.786133-1.604267 21.640533-2.6624 10.820267-1.092267 21.7088-1.604267Q501.111467 68.266667 512 68.266667q10.922667 0 21.777067 0.546133 10.888533 0.512 21.7088 1.604267 10.8544 1.024 21.6064 2.6624 10.786133 1.604267 21.504 3.720533 10.6496 2.116267 21.230933 4.778667 10.581333 2.628267 20.992 5.802666 10.410667 3.140267 20.6848 6.826667 10.24 3.652267 20.309333 7.850667 10.069333 4.164267 19.899734 8.8064 9.864533 4.642133 19.456 9.796266 9.6256 5.12 18.944 10.717867 9.352533 5.597867 18.432 11.6736 9.045333 6.0416 17.783466 12.526933t17.169067 13.380267q8.430933 6.929067 16.4864 14.2336 8.0896 7.304533 15.7696 15.018667 7.714133 7.714133 15.018667 15.7696 7.338667 8.0896 14.2336 16.4864 6.929067 8.430933 13.4144 17.169066 6.485333 8.772267 12.526933 17.8176t11.639467 18.397867q5.632 9.352533 10.752 18.944t9.796266 19.456q4.642133 9.8304 8.8064 19.899733 4.1984 10.069333 7.850667 20.309334 3.6864 10.24 6.826667 20.6848 3.1744 10.410667 5.802666 20.992 2.6624 10.581333 4.778667 21.265066 2.1504 10.6496 3.754667 21.435734 1.570133 10.786133 2.628266 21.6064 1.092267 10.8544 1.604267 21.7088 0.546133 10.922667 0.546133 21.777066z"
                    fill="#3fa2c7"
                    fill-opacity="0.1"
                    p-id="3777"
                  />
                  <path
                    d="M71.68 325.973333Q34.133333 414.72 34.133333 511.8976q0 97.211733 37.546667 186.026667 36.283733 85.742933 102.4 151.8592 66.1504 66.116267 151.893333 102.4 88.814933 37.546667 186.026667 37.546666 97.211733 0 186.026667-37.546666 85.742933-36.283733 151.893333-102.4 66.116267-66.116267 102.4-151.893334 37.546667-88.7808 37.546667-185.992533 0-97.1776-37.546667-185.992533-36.283733-85.742933-102.4-151.8592-66.1504-66.116267-151.893333-102.4Q609.211733 34.133333 512 34.133333q-97.211733 0-186.026667 37.546667-85.742933 36.283733-151.893333 102.4-66.116267 66.116267-102.4 151.893333z m62.907733 345.361067Q102.4 595.285333 102.4 511.931733q0-83.319467 32.187733-159.402666 31.061333-73.489067 87.790934-130.184534 56.695467-56.661333 130.184533-87.790933Q428.6464 102.4 512 102.4t159.402667 32.1536q73.5232 31.095467 130.218666 87.790933 56.7296 56.695467 87.790934 130.184534 32.187733 76.0832 32.187733 159.402666 0 83.3536-32.187733 159.402667-31.061333 73.489067-87.790934 130.184533-56.695467 56.7296-130.184533 87.790934-76.0832 32.187733-159.4368 32.187733t-159.402667-32.187733q-73.5232-31.061333-130.218666-87.790934-56.7296-56.661333-87.790934-130.184533z"
                    fill="#3fa2c7"
                    p-id="3778"
                  />
                  <path
                    d="M584.2944 657.2032H785.066667l-37.7856-16.657067v-248.081066L785.066667 375.466667h-127.931734l-145.646933 145.3056L363.178667 375.466667H238.933333l36.078934 16.9984v248.081066L238.933333 657.2032h199.0656l-35.7376-16.657067v-93.252266l104.106667 138.171733h10.581333l102.741334-138.171733v92.910933l-35.396267 16.9984z"
                    fill="#3fa2c7"
                    p-id="3779"
                  />
                </svg>
                {{ obj.totalOrnamentsPrice }}
              </div>
            </div>
          </div>
          <div class="room_center">
            <div class="condition">
              参与条件:{{
                obj.minRecharge == 0
                  ? "所有用户均可参与"
                  : `自开启之日起充值${obj.minRecharge}即可参与`
              }}
            </div>
            <div>房间简介:{{ obj.description || "暂无" }}</div>
            <div class="empty"></div>
          </div>
          <div class="room_bottom space_between">
            <div class="bottom_left">
              开奖时间
              <div
                :class="{
                  txt_finish: obj.rollStatus == 1,
                  txt_anchor: obj.rollStatus != 1 && obj.rollType == 1,
                  txt_official: obj.rollStatus != 1 && obj.rollType == 0,
                }"
              >
                {{ obj.endTime }}
              </div>
              <!-- <div style="color: rgba(78, 78, 78, 1)" v-else>{{ obj.endTime }}</div> -->
            </div>
            <div class="bottom_right btn_click">
              <div
                class="btn"
                v-if="obj.rollStatus == '0' && obj.rollType == '0'"
                @click="
                  handlejoin();
                  playAudio();
                "
              >
                <svg
                  t="1707014393388"
                  divBox="0 0 3973 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3533"
                  width="100%"
                  height="100%"
                >
                  <path
                    d="M0 1024h3778.56V0H501.76L0 1024z"
                    fill="#12d7ff"
                    fill-opacity="0.2"
                    p-id="3534"
                  />
                  <path
                    d="M194.56 1024h3778.56V0H696.32L194.56 1024z"
                    fill="#12d7ff"
                    p-id="3535"
                  />
                </svg>
                <div class="ic">加入房间</div>
              </div>
              <div class="btn" v-if="obj.rollStatus == '1'">
                <svg
                  t="1707017311670"
                  divBox="0 0 3973 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3679"
                  width="100%"
                  height="100%"
                >
                  <path
                    d="M0 1024h3778.56V0H501.76L0 1024z"
                    fill="#4E4E4E"
                    fill-opacity="0.2"
                    p-id="3680"
                  />
                  <path
                    d="M194.56 1024h3778.56V0H696.32L194.56 1024z"
                    fill="#4E4E4E"
                    p-id="3681"
                  />
                </svg>
                <div class="ic">已结束</div>
              </div>
              <div
                class="btn"
                v-if="obj.rollStatus == '0' && obj.rollType == '1'"
                @click="
                  handlejoin();
                  playAudio();
                "
              >
                <svg
                  t="1707014393388"
                  divBox="0 0 3973 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3533"
                  width="100%"
                  height="100%"
                >
                  <path
                    d="M0 1024h3778.56V0H501.76L0 1024z"
                    fill="#3fa2c7"
                    fill-opacity="0.2"
                    p-id="3534"
                  />
                  <path
                    d="M194.56 1024h3778.56V0H696.32L194.56 1024z"
                    fill="#3fa2c7"
                    p-id="3535"
                  />
                </svg>
                <div class="ic">加入房间</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bot-bg roomType0"></div>
      </div>
      <!-- <button @click="ceshi">开奖</button> -->
      <div class="main">
        <div class="main_top space_around">
          <div
            @click="
              handletype(0);
              playAudio();
            "
            :class="type == 0 ? 'active' : ''"
            class="btn center"
          >
            奖池
          </div>
          <div
            @click="
              handletype(1);
              playAudio();
            "
            :class="type == 1 ? 'active' : ''"
            class="btn center"
          >
            获奖名单
          </div>
          <div
            @click="
              handletype(2);
              playAudio();
            "
            :class="type == 2 ? 'active' : ''"
            class="btn center"
          >
            参与人员
          </div>
        </div>
        <div
          class="main_main animate__animated"
          v-if="type == 0"
          ref="rollelement"
          @scroll="rollPrizePoolScroll"
        >
          <div
            v-if="rollPrizePool.length != 0"
            class="grade3 animate__animated ornamentsList"
          >
            <div
              class="main_w column"
              v-for="(item, index) in rollPrizePool"
              :key="index"
            >
              <!-- {{ item }} -->
              <!-- <div
            :style="{ 'background-image': 'url(apple.png)'}"
              class="main_w_0"
             
            > -->
              <div
                class="main_w_0"
                :style="{ 'background-image': `url(${item.ornamentLevelImg})` }"
              >
                <div class="main_w_0_img">
                  <img
                    :src="$getFullPath(item.imgUrl)"
                    alt
                    style="width: 100%; height: 100%"
                  />
                </div>
              </div>
              <div class="textover-f">{{ item.ornamentName }}</div>
              <div class="money-money">
                <money class="money"></money>
                {{ item.price }}
              </div>
              <!-- <div class="goodsNum">{{ item.ornamentsNum }}</div> -->
            </div>
          </div>
          <div class="animate__animated" v-else>暂无</div>
        </div>
        <div
          class="main_main animate__animated"
          v-if="type == 1"
          ref="rollelement"
          @scroll="awardResultScroll"
        >
          <div v-if="awardResult.length != 0" class="grade3">
            <!--obj.awardResult[0]不存在  -->
            <div
              class="main_w column"
              v-for="(item, index) in awardResult"
              :key="index"
              :style="{ 'background-image': `url(${item.ornamentLevelImg})` }"
            >
              <!-- {{ item }} -->
              <div class="main_w_1">
                <div class="main_w_1_img">
                  <img
                    :src="$getFullPath(item.imageUrl)"
                    alt
                    width="100%"
                    height="100%"
                  />
                </div>
              </div>
              <div class="textover-f">{{ item.ornamentName }}</div>

              <div class="space_between main_w_1_1">
                <div class="avatar">
                  <img
                    :src="$getFullPath(item.avatar)"
                    alt
                    width="100%"
                    height="100%"
                    v-if="item.avatar"
                  />
                </div>
                <!-- <div class="nickName">{{ item.holderUserNickName }}</div> -->
                <div class="money-money">
                  <money class="money"></money>
                  {{ item.ornamentsPrice }}
                </div>
              </div>
            </div>
          </div>
          <div class="animate__animated" v-else>暂无</div>
        </div>
        <div
          class="main_main animate__animated"
          v-if="type == 2"
          ref="rollelement"
          @scroll="RollPlayersScroll"
        >
          <div v-if="playerList.length != 0" class="grade4">
            <div
              class="column"
              v-for="(item, index) in playerList"
              :key="index"
            >
              <!-- {{ item }} -->
              <div class="main_w_2">
                <img
                  :src="$getFullPath(item.avatar)"
                  alt
                  width="100%"
                  height="100%"
                />
              </div>
              <!-- <div class="textover-f">{{ item.nickName }}</div> -->
            </div>
          </div>
          <div class v-else>暂无</div>
        </div>
      </div>
      <!-- 输入密码弹框 -->
      <div class="isjoin_bg" v-if="isjoin">
        <div class="isjoin column">
          <!-- <input
          type="text"
          class="inputPass"
          v-model="pass"
          placeholder="请输入密码"
        /> -->
          <div class="roll_serch">
            <input
              type="text"
              v-model="pass"
              name
              id
              style="serch"
              placeholder="请输入ROLL房密码"
            />
          </div>
          <div class="lvbu"></div>
          <div class="isjoin_btn space_around">
            <div
              class="center isjoin_btn_console"
              @click="
                close();
                playAudio();
              "
            >
              取消
            </div>
            <div
              class="center isjoin_btn_true"
              @click="
                join();
                playAudio();
              "
            >
              加入
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalJoinRoll
      :showModal="isjoin"
      @close="isjoin = false"
      @confirm="join"
    ></modalJoinRoll>
  </div>
</template>

<script>
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import modalJoinRoll from "@/components/common/modalJoinRoll.vue";
import {
  getRollDetial,
  joinRoll,
  getRollPlayers,
  getRollOpenPrize,
  getRollPrizePool,
  endRoll,
} from "@/api/index";
export default {
  components: {
    otherHeaderTop,
    modalJoinRoll,
  },
  data() {
    return {
      pass: "",
      type: 2,
      id: localStorage.getItem("rollid"),
      obj: {},
      playerList: [],
      awardResult: [],
      awardResultIsover: "加载中",
      playerListIsover: "加载中",
      rollPrizePoolIsover: "加载中",
      isjoin: false,
      list: [],
      rollPrizePool: [],
      rollPrizePoolPage: {
        page: 1,
        size: 12,
        rollId: localStorage.getItem("rollid"),
      },
      playersPage: {
        page: 1,
        size: 20,
        rollId: localStorage.getItem("rollid"),
      },
      openPage: { page: 1, size: 12, rollId: localStorage.getItem("rollid") },
      // 新的
      id: "",
      info: {
        user_id: 0,
        conditions: [],
      },
      lists: [],
      userLists: [],
      page: 1,
      limit: 50,
      isOver: false,
      showJoinInfo: false,
      userPage: 1,
      userLimit: 50,
      userIsOver: false,
      isJoining: false,
      user: {},
    };
  },
  created() {
    const id = this.$route.query.id;
    this.id = id;
    this.rollPrizePoolPage.rollId = id;
    this.playersPage.rollId = id;
    this.openPage.rollId = id;
    this.getDetial();
  },
  mounted() {
    this.RollPlayers();
    this.RollPrizePool();
    this.RollOpenPrize();
  },
  computed: {
    isUserJoined() {
      return this.playerList.some(
        (user) => user.userId == this.$store.state.USER_INFO.userId
      );
    },
  },
  methods: {
    doJoin() {},
    openJoinUsers() {
      console.log("点击到没有");
      this.showJoinInfo = !this.showJoinInfo;
      if (this.showJoinInfo) {
        this.$soundPlay("pkPull");
      } else {
        this.$soundPlay("pkDown");
      }
    },
    getUsers() {},
    getGoods() {},
    getInfo() {},
    back() {
      this.$router.go(-1);
      this.$soundPlay("click");
    },
    // 旧的
    ceshi() {
      endRoll(this.id).then((res) => {
        console.log("开奖测试", res);
      });
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    RollPrizePool() {
      getRollPrizePool(this.rollPrizePoolPage).then((res) => {
        console.log("奖池", res);
        let arr = res.data.data;
        arr.forEach((item) => {
          for (let i = 1; i <= item.ornamentsNum; i++) {
            this.rollPrizePool.push(item);
          }
        });
        // this.rollPrizePool.push(...res.data.data);
      });
    },
    RollPlayers() {
      getRollPlayers(this.playersPage).then((res) => {
        this.playerList.push(...res.data.data);
        console.log("参与人员", res);
        if (res.data.data.length < this.playersPage.size) {
          this.playerListIsover = "暂无更多";
        }
      });
    },
    RollOpenPrize() {
      getRollOpenPrize(this.openPage).then((res) => {
        console.log("开奖", res);
        this.awardResult.push(...res.data.data);
        if (res.data.data.length < this.openPage.size) {
          this.awardResultIsover = "暂无更多";
        }
      });
    },
    rollPrizePoolScroll(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // console.log(11);

        if (this.playerListIsover == "加载中") {
          this.rollPrizePoolPage.page++;
          setTimeout(() => {
            this.RollPrizePool();
          }, 5);
        }
      }
    },
    RollPlayersScroll(e) {
      this.event = e;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // console.log(11);

        if (this.playerListIsover == "加载中") {
          this.playersPage.page++;
          setTimeout(() => {
            this.RollPlayers();
          }, 5);
        }
      }
    },
    awardResultScroll(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // console.log(11);

        if (this.awardResultIsover == "加载中") {
          this.openPage.page++;
          setTimeout(() => {
            this.RollOpenPrize();
          }, 5);
        }
      }
    },
    handleilltate() {
      this.$bus.$emit("is_illustrate", true);
      setTimeout(() => {
        this.$bus.$emit("nr_illustrate", "roll");
      }, 100);
    },
    close() {
      this.isjoin = false;
      this.pass = "";
    },
    join(password) {
      joinRoll(this.id, password).then((res) => {
        if (res.data.code == 200) {
          this.getDetial();
          this.playersPage.page = 1;
          this.playerList = [];
          this.RollPlayers();
          this.isjoin = false;
          this.$message({
            duration: 1000,
            message: "加入成功请等待开奖",
            type: "success",
            customClass: "log_success",
          });
        } else {
          this.$message({
            duration: 1000,
            message: res.data.msg,
            type: "warning",
            customClass: "log_warning",
          });
        }
      });
    },
    handlejoin() {
      console.log(111);
      if (this.obj.hasPW) {
        this.isjoin = true;
        return;
      }
      this.join();
    },
    handletype(res) {
      this.type = res;
      console.log(this.type);
      const el = this.$refs.rollelement;
      el.className += " animate__fadeIn";
      setTimeout(() => {
        el.classList.remove("animate__fadeIn");
      }, 350);
      // this.getDetial();
    },
    getDetial() {
      getRollDetial(this.id).then((res) => {
        this.obj = res.data.data;
        this.list = this.obj.jackpotOrnamentsDataList.sort((a, b) => {
          return b.price - a.price;
        });
        console.log("getDetial", this.obj);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.roll-info {
  --head-height: 14 * 4.2px;
}
.roll-detail-page {
  // padding-top: 60px;
}
.roll-detail-page .flex-box-div {
  height: 100%;
}

.roll-detail-page .roll-header {
  position: relative;
  margin: 1.6 * 4.2px 0 0 3.33 * 4.2px;
}

.roll-detail-page .roll-header .room-type {
  position: absolute;
  width: 16.13 * 4.2px;
  height: 4.53 * 4.2px;
  left: 2.8 * 4.2px;
  top: 12.27 * 4.2px;
  background: url("../../../assets/images/k21.png") no-repeat 0 0;
  background-size: 16.13 * 4.2px 4.13 * 4.2px;
  z-index: 1;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  text-align: right;
  font-size: 3.33 * 4.2px;
  font-weight: 700;
  color: #ffffff;
  line-height: 4 * 4.2px;
}

.roll-detail-page .roll-header .room-type.type-1 {
  background: url("../../../assets/images/type_tag_bg.png") no-repeat 0 0;
  background-size: 16.13 * 4.2px 4.13 * 4.2px;
}

.roll-detail-page .roll-header .room-type div {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  padding-left: 2.67 * 4.2px;
  text-align: left;
}

.roll-detail-page .roll-header .info-1 {
  width: 93.47 * 4.2px;
  height: 19.6 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 2.8 * 4.2px;
  padding-top: 2.93 * 4.2px;
  position: relative;
  background: url("../../../assets/images/top_box_bg.png") no-repeat 0 0;
  background-size: 93.47 * 4.2px 19.6 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.roll-detail-page .roll-header .info-1.info-type-anchor {
  background: url("../../../assets/images/top_box_bg2.png") no-repeat 0 0;
  background-size: 93.47 * 4.2px 19.6 * 4.2px;
}

.roll-detail-page .roll-header .info-1 .avatar {
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  -webkit-border-radius: 6.67 * 4.2px;
  border-radius: 6.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.roll-detail-page .roll-header .info-1 .avatar img {
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  -webkit-border-radius: 6.67 * 4.2px;
  border-radius: 6.67 * 4.2px;
}

.roll-detail-page .roll-header .info-1 .avatar:after {
  content: "";
  display: block;
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  background: url("../../../assets/images/head_bk.png") no-repeat 0 0;
  background-size: 13.33 * 4.2px 13.33 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
}

.roll-detail-page .roll-header .info-1 .info-1-middle {
  width: 41.6 * 4.2px;
  height: auto;
  margin-left: 2.67 * 4.2px;
  font-size: 3.33 * 4.2px;
}

.roll-detail-page .roll-header .info-1 .info-1-middle .name {
  height: 6.67 * 4.2px;
  font-size: 4.27 * 4.2px;
  color: #ffffff;
  text-align: left;
}

.roll-detail-page .roll-header .info-1 .info-1-middle .time {
  width: 37.33 * 4.2px;
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
  padding-left: 1.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 3.2 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.roll-detail-page .roll-header .info-1 .info-1-middle .time img {
  width: 3.47 * 4.2px;
  height: 3.47 * 4.2px;
  display: inline-block;
  margin-right: 1.33 * 4.2px;
}

.roll-detail-page .roll-header .info-1 .join-btn {
  width: 29.07 * 4.2px;
  height: 9.07 * 4.2px;
  background: url("../../../assets/images/join_btn.png") no-repeat 0 0;
  background-size: 29.07 * 4.2px 9.07 * 4.2px;
  position: absolute;
  top: 5.2 * 4.2px;
  right: 2.93 * 4.2px;
  line-height: 9.07 * 4.2px;
  text-align: center;
  color: #fff8e0;
  font-weight: 700;
  font-size: 4.4 * 4.2px;
}

.roll-detail-page .roll-header .info-1 .join-btn.is-ended {
  background: url("../../../assets/images/join_btn_end.png") no-repeat 0 0;
  background-size: 31.2 * 4.2px 9.07 * 4.2px;
  color: #ffffff;
}

.roll-detail-page .roll-detail-content {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  // height: -webkit-calc(100% - var(--head-height));
  height: calc(100vh - 50px);
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0 0 6.67 * 4.2px;
}

.roll-detail-page .roll-detail-content .van-list-inner {
  min-height: 85.33 * 4.2px;
  max-height: 125.33 * 4.2px;
  overflow: hidden;
  overflow-y: auto;
}

.roll-detail-page .roll-detail-content .roll-info {
  width: 93.47 * 4.2px;
  max-height: 96 * 4.2px;
  margin: 0 auto;
  position: relative;
}

.roll-detail-page .roll-detail-content .info-2 {
  width: 87.73 * 4.2px;
  max-height: 69.33 * 4.2px;
  overflow: hidden;
  font-size: 3.2 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 auto 5.33 * 4.2px;
  background: url("../../../assets/images/k41.png") no-repeat 0 0;
  background-size: 87.73 * 4.2px 69.33 * 4.2px;
  padding-bottom: 4 * 4.2px;
}

.roll-detail-page .roll-detail-content .info-2 .desc-item {
  width: 81.87 * 4.2px;
  height: 11.47 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #657ed8;
  font-size: 3.33 * 4.2px;
  margin: 0 auto;
  position: relative;
}

.roll-detail-page .roll-detail-content .info-2 .desc-item:after {
  content: "";
  display: block;
  width: 81.87 * 4.2px;
  height: 1px;
  background: url("../../../assets/images/line17.png") no-repeat 0 0;
  background-size: 81.87 * 4.2px 1px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.roll-detail-page .roll-detail-content .info-2 .desc-item .icon {
  width: 6.93 * 4.2px;
  height: 5.87 * 4.2px;
  margin-right: 3.07 * 4.2px;
  float: left;
}

.roll-detail-page .roll-detail-content .info-2 .desc-item .desc-text {
  width: 68.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  margin-top: 0.67 * 4.2px;
}

.roll-detail-page .roll-detail-content .info-2 .tip-text {
  width: 79.73 * 4.2px;
  height: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  padding-top: 2.8 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 3.33 * 4.2px;
  margin: 0 auto;
  color: #657ed8;
}

.roll-detail-page .roll-detail-content .info-2 .tip-text .text {
  line-height: 6.13 * 4.2px;
}

.roll-detail-page .roll-detail-content .info-2 .tip-text img {
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
  margin: 0 5.2 * 4.2px 0 3.73 * 4.2px;
}

.roll-detail-page .roll-detail-content .progress-box-wrap {
  width: 100 * 4.2px;
  height: 14.13 * 4.2px;
  background: url("../../../assets/images/opening_box_bg.png") no-repeat 0 0;
  background-size: 100 * 4.2px 14.13 * 4.2px;
  padding-top: 7.2 * 4.2px;
  padding-bottom: 2.67 * 4.2px;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.roll-detail-page .roll-detail-content .progress-box-wrap .opening-text {
  width: 100%;
  height: auto;
  text-align: center;
  font-size: 3.33 * 4.2px;
  color: #45ffe8;
  position: absolute;
  left: 0;
  top: -0.53 * 4.2px;
}

.roll-detail-page
  .roll-detail-content
  .progress-box-wrap.finish-open
  .opening-text {
  color: #ffd122;
}

.roll-detail-page
  .roll-detail-content
  .progress-box-wrap.finish-open
  .progress-outer {
  overflow: hidden;
}

.roll-detail-page
  .roll-detail-content
  .progress-box-wrap.finish-open
  .progress-outer
  .progress-inner {
  background: url("../../../assets/images/bar_active_bg3.png") repeat 0 0;
  background-size: 79.47 * 4.2px 1.33 * 4.2px;
  width: 900 * 4.2px;
  -webkit-transform: translateX(-479.47 * 4.2px);
  -ms-transform: translateX(-479.47 * 4.2px);
  transform: translateX(-479.47 * 4.2px);
  -webkit-animation: progressMove-data-v-4a51407c 5s infinite linear;
  animation: progressMove-data-v-4a51407c 5s infinite linear;
}

@-webkit-keyframes progressMove-data-v-4a51407c {
  0% {
    -webkit-transform: translateX(-3596px);
    transform: translateX(-3596px);
  }

  100% {
    -webkit-transform: translateX(-800px);
    transform: translateX(-800px);
  }
}

@keyframes progressMove-data-v-4a51407c {
  0% {
    -webkit-transform: translateX(-3596px);
    transform: translateX(-3596px);
  }

  100% {
    -webkit-transform: translateX(-800px);
    transform: translateX(-800px);
  }
}

.roll-detail-page .roll-detail-content .result-content {
  width: 87.6 * 4.2px;
  height: 20.4 * 4.2px;
  margin-left: 6.27 * 4.2px;
  background: url("../../../assets/images/res_win.png") no-repeat 0 0;
  background-size: 87.6 * 4.2px 20.4 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  margin-bottom: 2.67 * 4.2px;
}

.roll-detail-page .roll-detail-content .result-content.fail {
  background: url("../../../assets/images/res_fail.png") no-repeat 0 0;
  background-size: 87.6 * 4.2px 20.4 * 4.2px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.roll-detail-page .roll-detail-content .result-content.fail .fail-msg {
  width: 66.4 * 4.2px;
  height: 6.13 * 4.2px;
  background: url("../../../assets/images/fail-msg.png") no-repeat 0 0;
  background-size: 66.4 * 4.2px 6.13 * 4.2px;
}

.roll-detail-page .roll-detail-content .result-content .gun {
  height: 100%;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.roll-detail-page .roll-detail-content .result-content .gun img {
  margin-left: 4 * 4.2px;
  width: 23.07 * 4.2px;
  height: 16 * 4.2px;
  -o-object-fit: cover;
  object-fit: cover;
}

.roll-detail-page .roll-detail-content .result-content .gun .level {
  position: absolute;
  left: 2.8 * 4.2px;
  bottom: 4.4 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #ffffff;
}

.roll-detail-page .roll-detail-content .result-content .msg {
  margin-left: 5.33 * 4.2px;
  width: 28 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  font-size: 2.67 * 4.2px;
  color: #ffffff;
}

.roll-detail-page .roll-detail-content .result-content .msg .name {
  margin-bottom: 1.33 * 4.2px;
}

.roll-detail-page .roll-detail-content .result-content .msg .price {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ffe2c0;
  font-family: "Alimama ShuHeiTi", serif;
  font-size: 3.33 * 4.2px;
}

.roll-detail-page .roll-detail-content .result-content .msg .price .bi {
  width: 2.67 * 4.2px;
  height: 2.53 * 4.2px;
  margin-right: 1.73 * 4.2px;
}

.roll-detail-page .roll-detail-content .result-content .tip {
  width: 27.07 * 4.2px;
  height: 6.13 * 4.2px;
  position: absolute;
  top: 6.93 * 4.2px;
  right: 0;
}

.roll-detail-page .roll-detail-content .progress-outer {
  width: 79.73 * 4.2px;
  height: 1.33 * 4.2px;
  background: url("../../../assets/images/k42.png") no-repeat 0 0;
  background-size: 79.73 * 4.2px 1.33 * 4.2px;
  position: relative;
}

.roll-detail-page .roll-detail-content .progress-outer .progress-num {
  width: 10.93 * 4.2px;
  height: 9.87 * 4.2px;
  background: url("../../../assets/images/k43.png") no-repeat 0 0;
  background-size: 10.93 * 4.2px 9.87 * 4.2px;
  position: absolute;
  left: 0;
  top: -8.27 * 4.2px;
  text-align: center;
  padding-top: 0.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 3.2 * 4.2px;
  color: #ffffff;
}

.roll-detail-page .roll-detail-content .progress-outer .progress-inner {
  width: 79.73 * 4.2px;
  height: 1.33 * 4.2px;
  background: url("../../../assets/images/k44.png") no-repeat 0 0;
  background-size: 78.4 * 4.2px 1.33 * 4.2px;
}

.roll-detail-page .roll-detail-content .roll-opening {
  margin-top: 1.33 * 4.2px;
}

.roll-detail-page .roll-detail-content .prod-list-wrap {
  width: 100 * 4.2px;
  height: calc(100vh - 358px);
  padding: 2.27 * 4.2px 0 0 0;
  margin-bottom: 30.4 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.roll-detail-page .roll-detail-content .prod-list-wrap .list-title {
  width: 100 * 4.2px;
  height: 9.07 * 4.2px;
  margin-bottom: 4 * 4.2px;
}

.roll-detail-page .roll-detail-content .prod-list-wrap .list-title img {
  width: 100 * 4.2px;
  height: 9.07 * 4.2px;
}

.roll-detail-page .roll-detail-content .prod-list-wrap .prod-list-content {
  width: 100 * 4.2px;
  padding-top: 2.67 * 4.2px;
  padding-left: 4.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: calc(100vh - 415px);
  overflow-y: scroll;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .list {
  width: 94.67 * 4.2px;
  // height: 100%;
  padding-left: 0.53 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(13.33 * 4.2px, auto);
  justify-items: start;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item {
  width: 28.13 * 4.2px;
  height: 25.87 * 4.2px;
  background: url("../../../assets/images/prod_golden_item.png") no-repeat 0 0;
  background-size: 28.13 * 4.2px 25.87 * 4.2px;
  margin-bottom: 2.93 * 4.2px;
  margin-right: 2.67 * 4.2px;
  position: relative;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item.sel {
  background: url("../../../assets/images/prod_item_sel_1.png") no-repeat 0 0;
  background-size: 29.07 * 4.2px 29.07 * 4.2px;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .top {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .top
  .user-info {
  width: 28.13 * 4.2px;
  height: 7.47 * 4.2px;
  position: absolute;
  color: #ecf0f9;
  background: url("../../../assets/images/k45.png") no-repeat 0 0;
  background-size: 28.13 * 4.2px 7.47 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  left: 0;
  top: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 3.2 * 4.2px;
  z-index: 1;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .top
  .user-info:after {
  content: "";
  display: block;
  width: 6.67 * 4.2px;
  height: 6.67 * 4.2px;
  background: url(data:image/png;base64,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)
    no-repeat 0 0;
  background-size: 6.67 * 4.2px 6.67 * 4.2px;
  position: absolute;
  left: 0.27 * 4.2px;
  top: 0.53 * 4.2px;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .top
  .user-info
  .avatar {
  width: 6.13 * 4.2px;
  height: 6.13 * 4.2px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  margin: 0.53 * 4.2px 0.67 * 4.2px 0;
  position: relative;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .top
  .user-info
  .nick {
  margin-left: 0.53 * 4.2px;
  font-size: 2.67 * 4.2px;
  width: 22.4 * 4.2px;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .top
  .prod-img {
  position: absolute;
  top: 0;
  left: 2.4 * 4.2px;
  width: 23.07 * 4.2px;
  height: 16 * 4.2px;
  padding-top: 1.07 * 4.2px;
  -o-object-fit: cover;
  object-fit: cover;
}
.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .top
  .prod-img
  img {
  width: 57px;
  height: auto;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .bottom
  .price {
  width: 100%;
  height: 5.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 1.33 * 4.2px 0 2.93 * 4.2px;
  color: #ffe2c0;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .bottom
  .bi {
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
  margin-right: 1.33 * 4.2px;
}

.roll-detail-page
  .roll-detail-content
  .prod-list-wrap
  .prod-list-content
  .prod-item
  .bottom
  .name {
  width: 24 * 4.2px;
  height: 5.6 * 4.2px;
  line-height: 5.6 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 3.33 * 4.2px;
  margin: 0 auto;
}

.roll-detail-page .bottom-user-list-wrap {
  width: 100 * 4.2px;
  min-height: 17.07 * 4.2px;
  position: relative;
  left: 0;
  bottom: 0;
  right: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: url("../../../assets/images/user_list_big_bg.png") no-repeat 0 0;
  background-size: 100 * 4.2px 143.33 * 4.2px;
  z-index: 1;
}

.roll-detail-page .bottom-user-list-wrap .close-btn {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
}

.roll-detail-page .bottom-user-list-wrap .line-box {
  width: 100 * 4.2px;
  height: 0.27 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAACAQMAAAA9ystZAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAGUExURSZb/yZb/63Z9o8AAAACdFJOU/r0IhDyCgAAABFJREFUCNdjaGCgIWBhoK3xAI/CAQms/6/TAAAAAElFTkSuQmCC)
    no-repeat 0 0;
  background-size: 100 * 4.2px 0.27 * 4.2px;
  position: absolute;
  left: 0;
  top: 13.33 * 4.2px;
}

.roll-detail-page .bottom-user-list-wrap .top-row {
  width: 100 * 4.2px;
  height: 5.73 * 4.2px;
  line-height: 6 * 4.2px;
  background: url("../../../assets/images/top-row.png") no-repeat center 0;
  background-size: 71.87 * 4.2px 5.73 * 4.2px;
  text-align: center;
  font-size: 3.33 * 4.2px;
  position: absolute;
  left: 0;
  top: -3.2 * 4.2px;
  z-index: 100;
}

.roll-detail-page .bottom-user-list-wrap .top-row.sel {
  background: url("../../../assets/images/top-row-sel.png") no-repeat center 0;
  background-size: 71.87 * 4.2px 5.73 * 4.2px;
}

.roll-detail-page .bottom-user-list-wrap .bottom-middle-content {
  width: 100 * 4.2px;
  min-height: 8.53 * 4.2px;
  position: relative;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.roll-detail-page .bottom-user-list-wrap .bottom-middle-content .total-box {
  width: 90.67 * 4.2px;
  height: 6.13 * 4.2px;
  margin: 4 * 4.2px auto 0 auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  font-size: 3.33 * 4.2px;
  color: #657ed8;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.roll-detail-page
  .bottom-user-list-wrap
  .bottom-middle-content
  .total-box
  .total-item {
  height: 6.13 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.roll-detail-page
  .bottom-user-list-wrap
  .bottom-middle-content
  .total-box
  .total-item
  img {
  width: 3.73 * 4.2px;
  height: 3.73 * 4.2px;
}

.roll-detail-page .bottom-user-list-wrap .bottom-row {
  width: 100 * 4.2px;
  height: 17.07 * 4.2px;
  background: url("../../../assets/images/popup_bottom_bg.png") no-repeat 0 0;
  background-size: 100 * 4.2px 17.07 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.roll-detail-page .enter-pwd-wrap .pwd-dialog-content .enter-pwd-content {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 13.33 * 4.2px 0 6.67 * 4.2px 0;
}

.roll-detail-page .enter-pwd-wrap .pwd-dialog-content .pwd-form {
  width: 67.47 * 4.2px;
  overflow: hidden;
}

.roll-detail-page .enter-pwd-wrap .pwd-dialog-content .pwd-form .li-div {
  width: 67.47 * 4.2px;
}

.roll-detail-page
  .enter-pwd-wrap
  .pwd-dialog-content
  .pwd-form
  .li-div
  .li-div-inner {
  width: 65.73 * 4.2px;
}

.roll-detail-page
  .enter-pwd-wrap
  .pwd-dialog-content
  .pwd-form
  .li-div
  .li-input {
  width: 54.67 * 4.2px;
}

.roll-detail-page .enter-pwd-wrap .pwd-dialog-content .pwd-form .input-item {
  margin-bottom: 2.53 * 4.2px;
}

.roll-detail-page
  .enter-pwd-wrap
  .pwd-dialog-content
  .pwd-form
  .input-item.new-pwd {
  margin-top: 8.53 * 4.2px;
  margin-bottom: 6.67 * 4.2px;
}

.roll-detail-page .dark-bg {
  opacity: 0.2;
  pointer-events: none;
}

.user-list-wrap {
  width: 100 * 4.2px;
  position: absolute;
  left: 0;
  top: 18 * 4.2px;
  right: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // overflow-x: hidden;
  // overflow-y: auto;
}

.user-list-wrap .user-list-content {
  width: 100%;
  height: 467px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 9.33 * 4.2px;
  padding-top: 3.2 * 4.2px;
  overflow-y: auto;
}

.user-list-wrap .user-list-content .user-item {
  width: 16.53 * 4.2px;
  height: auto;
  float: left;
  margin-right: 4.8 * 4.2px;
  margin-bottom: 4 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-list-wrap .user-list-content .user-item .nick {
  width: 16.53 * 4.2px;
  height: 8.53 * 4.2px;
  line-height: 4.27 * 4.2px;
  font-size: 3.2 * 4.2px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-list-wrap .user-list-content .user-item .avatar {
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  margin-bottom: 1.6 * 4.2px;
}

.user-list-wrap .user-list-content .user-item .avatar:after {
  content: "";
  display: block;
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  background: url(data:image/png;base64,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)
    no-repeat 0 0;
  background-size: 13.33 * 4.2px 13.33 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
}

.user-list-wrap .user-list-content .user-item .avatar img {
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  -webkit-border-radius: 6.67 * 4.2px;
  border-radius: 6.67 * 4.2px;
}
.appview {
  height: 100vh;
}
@media only screen and (max-width: 430px) {
  .roll-info {
    --head-height: 14vw;
  }

  .roll-detail-page .roll-header {
    margin: 1.6vw 0 0 3.33vw;
  }

  .roll-detail-page .roll-header .room-type {
    position: absolute;
    width: 16.13vw;
    height: 4.53vw;
    left: 2.8vw;
    top: 12.27vw;

    background-size: 16.13vw 4.13vw;

    font-size: 3.33vw;
    font-weight: 700;

    line-height: 4vw;
  }

  .roll-detail-page .roll-header .room-type.type-1 {
    background-size: 16.13vw 4.13vw;
  }

  .roll-detail-page .roll-header .room-type div {
    padding-left: 2.67vw;
  }

  .roll-detail-page .roll-header .info-1 {
    width: 93.47vw;
    height: 19.6vw;

    padding-left: 2.8vw;
    padding-top: 2.93vw;

    background-size: 93.47vw 19.6vw;
  }

  .roll-detail-page .roll-header .info-1.info-type-anchor {
    background-size: 93.47vw 19.6vw;
  }

  .roll-detail-page .roll-header .info-1 .avatar {
    width: 13.33vw;
    height: 13.33vw;
    -webkit-border-radius: 6.67vw;
    border-radius: 6.67vw;
  }

  .roll-detail-page .roll-header .info-1 .avatar img {
    width: 13.33vw;
    height: 13.33vw;
    -webkit-border-radius: 6.67vw;
    border-radius: 6.67vw;
  }

  .roll-detail-page .roll-header .info-1 .avatar:after {
    width: 13.33vw;
    height: 13.33vw;

    background-size: 13.33vw 13.33vw;
  }

  .roll-detail-page .roll-header .info-1 .info-1-middle {
    width: 41.6vw;

    margin-left: 2.67vw;
    font-size: 3.33vw;
  }

  .roll-detail-page .roll-header .info-1 .info-1-middle .name {
    height: 6.67vw;
    font-size: 4.27vw;
  }

  .roll-detail-page .roll-header .info-1 .info-1-middle .time {
    width: 37.33vw;
    height: 5.33vw;
    line-height: 5.33vw;
    padding-left: 1.33vw;

    font-size: 3.2vw;
  }

  .roll-detail-page .roll-header .info-1 .info-1-middle .time img {
    width: 3.47vw;
    height: 3.47vw;

    margin-right: 1.33vw;
  }

  .roll-detail-page .roll-header .info-1 .join-btn {
    width: 29.07vw;
    height: 9.07vw;

    background-size: 29.07vw 9.07vw;

    top: 5.2vw;
    right: 2.93vw;
    line-height: 9.07vw;

    font-weight: 700;
    font-size: 4.4vw;
  }

  .roll-detail-page .roll-header .info-1 .join-btn.is-ended {
    background-size: 31.2vw 9.07vw;
  }

  .roll-detail-page .roll-detail-content {
    padding: 0 0 6.67vw;
  }

  .roll-detail-page .roll-detail-content .van-list-inner {
    min-height: 85.33vw;
    max-height: 125.33vw;
  }

  .roll-detail-page .roll-detail-content .roll-info {
    width: 93.47vw;
    max-height: 96vw;
  }

  .roll-detail-page .roll-detail-content .info-2 {
    width: 87.73vw;
    max-height: 69.33vw;

    font-size: 3.2vw;

    margin: 0 auto 5.33vw;

    background-size: 87.73vw 69.33vw;
    padding-bottom: 4vw;
  }

  .roll-detail-page .roll-detail-content .info-2 .desc-item {
    width: 81.87vw;
    height: 11.47vw;

    font-size: 3.33vw;
  }

  .roll-detail-page .roll-detail-content .info-2 .desc-item:after {
    width: 81.87vw;

    background-size: 81.87vw 1px;
  }

  .roll-detail-page .roll-detail-content .info-2 .desc-item .icon {
    width: 6.93vw;
    height: 5.87vw;
    margin-right: 3.07vw;
  }

  .roll-detail-page .roll-detail-content .info-2 .desc-item .desc-text {
    width: 68.27vw;
    line-height: 4.27vw;
    margin-top: 0.67vw;
  }

  .roll-detail-page .roll-detail-content .info-2 .tip-text {
    width: 79.73vw;

    padding-top: 2.8vw;

    font-size: 3.33vw;
  }

  .roll-detail-page .roll-detail-content .info-2 .tip-text .text {
    line-height: 6.13vw;
  }

  .roll-detail-page .roll-detail-content .info-2 .tip-text img {
    width: 5.33vw;
    height: 5.33vw;
    margin: 0 5.2vw 0 3.73vw;
  }

  .roll-detail-page .roll-detail-content .progress-box-wrap {
    width: 100vw;
    height: 14.13vw;

    background-size: 100vw 14.13vw;
    padding-top: 7.2vw;
    padding-bottom: 2.67vw;
  }

  .roll-detail-page .roll-detail-content .progress-box-wrap .opening-text {
    font-size: 3.33vw;

    top: -0.53vw;
  }

  .roll-detail-page
    .roll-detail-content
    .progress-box-wrap.finish-open
    .progress-outer
    .progress-inner {
    background-size: 79.47vw 1.33vw;
    width: 900vw;
    -webkit-transform: translateX(-479.47vw);
    -ms-transform: translateX(-479.47vw);
    transform: translateX(-479.47vw);
  }

  .roll-detail-page .roll-detail-content .result-content {
    width: 87.6vw;
    height: 20.4vw;
    margin-left: 6.27vw;

    background-size: 87.6vw 20.4vw;

    margin-bottom: 2.67vw;
  }

  .roll-detail-page .roll-detail-content .result-content.fail {
    background-size: 87.6vw 20.4vw;
  }

  .roll-detail-page .roll-detail-content .result-content.fail .fail-msg {
    width: 66.4vw;
    height: 6.13vw;

    background-size: 66.4vw 6.13vw;
  }

  .roll-detail-page .roll-detail-content .result-content .gun img {
    margin-left: 4vw;
    width: 23.07vw;
    height: 16vw;
  }

  .roll-detail-page .roll-detail-content .result-content .gun .level {
    left: 2.8vw;
    bottom: 4.4vw;
    font-size: 3.33vw;
  }

  .roll-detail-page .roll-detail-content .result-content .msg {
    margin-left: 5.33vw;
    width: 28vw;

    font-size: 2.67vw;
  }

  .roll-detail-page .roll-detail-content .result-content .msg .name {
    margin-bottom: 1.33vw;
  }

  .roll-detail-page .roll-detail-content .result-content .msg .price {
    font-size: 3.33vw;
  }

  .roll-detail-page .roll-detail-content .result-content .msg .price .bi {
    width: 2.67vw;
    height: 2.53vw;
    margin-right: 1.73vw;
  }

  .roll-detail-page .roll-detail-content .result-content .tip {
    width: 27.07vw;
    height: 6.13vw;

    top: 6.93vw;
  }

  .roll-detail-page .roll-detail-content .progress-outer {
    width: 79.73vw;
    height: 1.33vw;

    background-size: 79.73vw 1.33vw;
  }

  .roll-detail-page .roll-detail-content .progress-outer .progress-num {
    width: 10.93vw;
    height: 9.87vw;

    background-size: 10.93vw 9.87vw;

    top: -8.27vw;

    padding-top: 0.67vw;

    font-size: 3.2vw;
  }

  .roll-detail-page .roll-detail-content .progress-outer .progress-inner {
    width: 79.73vw;
    height: 1.33vw;

    background-size: 78.4vw 1.33vw;
  }

  .roll-detail-page .roll-detail-content .roll-opening {
    margin-top: 1.33vw;
  }

  .roll-detail-page .roll-detail-content .prod-list-wrap {
    width: 100vw;
    height: calc(100vh - 358px);
    padding: 2.27vw 0 0 0;
    margin-bottom: 30.4vw;
  }

  .roll-detail-page .roll-detail-content .prod-list-wrap .list-title {
    width: 100vw;
    height: 9.07vw;
    margin-bottom: 4vw;
  }

  .roll-detail-page .roll-detail-content .prod-list-wrap .list-title img {
    width: 100vw;
    height: 9.07vw;
  }

  .roll-detail-page .roll-detail-content .prod-list-wrap .prod-list-content {
    width: 100vw;
    padding-top: 2.67vw;
    padding-left: 4.67vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .list {
    width: 94.67vw;

    padding-left: 0.53vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item {
    width: 28.13vw;
    height: 25.87vw;

    background-size: 28.13vw 25.87vw;
    margin-bottom: 2.93vw;
    margin-right: 2.67vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item.sel {
    background-size: 29.07vw 29.07vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item
    .top
    .user-info {
    width: 28.13vw;
    height: 7.47vw;

    background-size: 28.13vw 7.47vw;

    font-size: 3.2vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item
    .top
    .user-info:after {
    width: 6.67vw;
    height: 6.67vw;

    background-size: 6.67vw 6.67vw;

    left: 0.27vw;
    top: 0.53vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item
    .top
    .user-info
    .avatar {
    width: 6.13vw;
    height: 6.13vw;

    margin: 0.53vw 0.67vw 0;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item
    .top
    .user-info
    .nick {
    margin-left: 0.53vw;
    font-size: 2.67vw;
    width: 22.4vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item
    .top
    .prod-img {
    left: 2.4vw;
    width: 23.07vw;
    height: 16vw;
    padding-top: 1.07vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item
    .bottom
    .price {
    height: 5.33vw;

    padding: 0 1.33vw 0 2.93vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item
    .bottom
    .bi {
    width: 3.87vw;
    height: 3.6vw;
    margin-right: 1.33vw;
  }

  .roll-detail-page
    .roll-detail-content
    .prod-list-wrap
    .prod-list-content
    .prod-item
    .bottom
    .name {
    width: 24vw;
    height: 5.6vw;
    line-height: 5.6vw;

    font-size: 3.33vw;
  }

  .roll-detail-page .bottom-user-list-wrap {
    width: 100vw;
    min-height: 17.07vw;

    background-size: 100vw 143.33vw;
  }

  .roll-detail-page .bottom-user-list-wrap .close-btn {
    width: 100%;
  }

  .roll-detail-page .bottom-user-list-wrap .line-box {
    width: 100vw;
    height: 0.27vw;

    background-size: 100vw 0.27vw;

    top: 13.33vw;
  }

  .roll-detail-page .bottom-user-list-wrap .top-row {
    width: 100vw;
    height: 5.73vw;
    line-height: 6vw;

    background-size: 71.87vw 5.73vw;

    font-size: 3.33vw;

    top: -3.2vw;
  }

  .roll-detail-page .bottom-user-list-wrap .top-row.sel {
    background-size: 71.87vw 5.73vw;
  }

  .roll-detail-page .bottom-user-list-wrap .bottom-middle-content {
    width: 100vw;
    min-height: 8.53vw;
  }

  .roll-detail-page .bottom-user-list-wrap .bottom-middle-content .total-box {
    width: 90.67vw;
    height: 6.13vw;
    margin: 4vw auto 0 auto;

    font-size: 3.33vw;
  }

  .roll-detail-page
    .bottom-user-list-wrap
    .bottom-middle-content
    .total-box
    .total-item {
    height: 6.13vw;
  }

  .roll-detail-page
    .bottom-user-list-wrap
    .bottom-middle-content
    .total-box
    .total-item
    img {
    width: 3.73vw;
    height: 3.73vw;
  }

  .roll-detail-page .bottom-user-list-wrap .bottom-row {
    width: 100vw;
    height: 17.07vw;

    background-size: 100vw 17.07vw;
  }

  .roll-detail-page .enter-pwd-wrap .pwd-dialog-content .enter-pwd-content {
    padding: 13.33vw 0 6.67vw 0;
  }

  .roll-detail-page .enter-pwd-wrap .pwd-dialog-content .pwd-form {
    width: 67.47vw;
  }

  .roll-detail-page .enter-pwd-wrap .pwd-dialog-content .pwd-form .li-div {
    width: 67.47vw;
  }

  .roll-detail-page
    .enter-pwd-wrap
    .pwd-dialog-content
    .pwd-form
    .li-div
    .li-div-inner {
    width: 65.73vw;
  }

  .roll-detail-page
    .enter-pwd-wrap
    .pwd-dialog-content
    .pwd-form
    .li-div
    .li-input {
    width: 54.67vw;
  }

  .roll-detail-page .enter-pwd-wrap .pwd-dialog-content .pwd-form .input-item {
    margin-bottom: 2.53vw;
  }

  .roll-detail-page
    .enter-pwd-wrap
    .pwd-dialog-content
    .pwd-form
    .input-item.new-pwd {
    margin-top: 8.53vw;
    margin-bottom: 6.67vw;
  }

  .user-list-wrap {
    width: 100vw;

    top: 18vw;
  }

  .user-list-wrap .user-list-content {
    padding-left: 9.33vw;
    padding-top: 3.2vw;
  }

  .user-list-wrap .user-list-content .user-item {
    width: 16.53vw;

    margin-right: 4.8vw;
    margin-bottom: 4vw;
  }

  .user-list-wrap .user-list-content .user-item .nick {
    width: 16.53vw;
    height: 8.53vw;
    line-height: 4.27vw;
    font-size: 3.2vw;
  }

  .user-list-wrap .user-list-content .user-item .avatar {
    width: 13.33vw;
    height: 13.33vw;

    margin-bottom: 1.6vw;
  }

  .user-list-wrap .user-list-content .user-item .avatar:after {
    width: 13.33vw;
    height: 13.33vw;

    background-size: 13.33vw 13.33vw;
  }

  .user-list-wrap .user-list-content .user-item .avatar img {
    width: 13.33vw;
    height: 13.33vw;
    -webkit-border-radius: 6.67vw;
    border-radius: 6.67vw;
  }
  .roll-detail-page {
    padding-top: 0;
  }
}
</style>
